import React from 'react'
import { Box, styled, Typography } from '@mui/material'
import { visuallyHidden } from '@mui/utils'
import { FORMULA_SHEET_SECTIONS, FormulaLine } from './formulaSheetContent'

const FormulaSheetLine: React.FC<{ line: FormulaLine }> = ({ line }) => {
  if (!line.spokenText) return <li>{line.visual}</li>

  return (
    <li>
      <span aria-hidden='true'>{line.visual}</span>
      <Box component='span' sx={visuallyHidden}>
        {line.spokenText}
      </Box>
    </li>
  )
}

export const FormulaSheet: React.FC = () => (
  <div data-automation-id='formula-sheet'>
    {FORMULA_SHEET_SECTIONS.map(section => (
      <Section key={section.id} data-automation-id={`formula-sheet-section-${section.id}`}>
        <SectionHeading component='h3' variant='body1'>
          {section.heading}
        </SectionHeading>
        {/* a11y: role="list" keeps list semantics in Safari/VoiceOver, which drops them when list-style is none */}
        {/* eslint-disable-next-line jsx-a11y/no-redundant-roles */}
        <LineList role='list'>
          {section.lines.map((line, index) => (
            <FormulaSheetLine key={`${section.id}-${index}`} line={line} />
          ))}
        </LineList>
      </Section>
    ))}
  </div>
)

const Section = styled('section')(({ theme }) => ({
  marginBottom: theme.spacing(4),
}))

const SectionHeading = styled(Typography)(({ theme }) => ({
  fontWeight: theme.typography.fontWeightBold,
  marginBottom: theme.spacing(1),
})) as typeof Typography

const LineList = styled('ul')(() => ({
  listStyle: 'none',
  margin: 0,
  padding: 0,
}))
